import { get, remove, post, put } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchVariants =
  (requestParams = {}) =>
  dispatch =>
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get('/variants', { pagination: false, ...requestParams }).then(response => {
      dispatch({
        type: types.FETCH_VARIANTS,
        payload: {
          variants: response['hydra:member'],
        },
      });
    });

export const fetchVariant =
  (id, requestParams = {}) =>
  dispatch =>
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get(`/variants/${id}`, requestParams).then(variant => {
      dispatch({
        type: types.FETCH_VARIANT,
        payload: {
          variant,
        },
      });
      return variant;
    });

export const removeVariant = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  remove(`/variants/${id}`).then(() => {
    dispatch({
      type: types.REMOVE_VARIANT,
      payload: {
        variantId: id,
      },
    });
  });

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
export const addVariant = data => dispatch => post('/variants', data);

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
export const editVariant = (id, data) => dispatch =>
  put(`/variants/${id}`, data);
